import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fetcher, { URLBuild } from '../../services/fetcher';
import settings from '../../settings';
import { LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexFlow: 'column',
    flex: 1,
    marginBottom: theme.spacing(2),
    textAlign: 'center'
  },
  title: {
    marginTop: '12px',
    marginBottom: '5px',
    fontSize: "1rem"
  },
  table: {
    minWidth: 650,
    position: 'relative',
  },
  tableHead: {
    verticalAlign: 'bottom',
  },
}));

interface Period {
  all: number;
  year: number;
  month: number;
  None: number;
};

interface StatByWay {
  paymentWay: "all" | "stripe" | "check" | "android" | "apple"; // | "ogone"
  period: Period;
}

const paymentWayTranslateMap = {
  "all": "Tous les moyens de paiement",
  "stripe": "Stripe",
  "android": "Android (connecté à un compte)",
  "apple": "Apple (connecté à un compte)",
  "check": "Chèque",
};

const PaymentWayTable = ({ isMobile }: { isMobile?: boolean }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(0);
  const [data, setData] = useState<StatByWay[] | null>(null);

  useEffect(() => {
    setLoading((prev) => prev + 1);
    Fetcher.get(
      URLBuild(settings.PaymentProvider.paymentApi + '/stat/all', { active: true })
    ).then((fetched: {data: StatByWay[]}) => {
      setData(fetched.data);
      setLoading((prev) => prev - 1);
    });
  }, [])

  return (
    <div className={classes.container}>
      <TableContainer component={Paper}>
        <div className={classes.title}>Clients avec un abonnement pour le { new Date().toLocaleDateString() }</div>
        <Table className={classes.table} size={isMobile ? "small" : undefined} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHead}>Moyen de paiement</TableCell>
              <TableCell component="th" className={classes.tableHead}>Toutes les périodicités</TableCell>
              <TableCell component="th" className={classes.tableHead}>Annuelle</TableCell>
              <TableCell component="th" className={classes.tableHead}>Mensuelle</TableCell>
              <TableCell component="th" className={classes.tableHead}>Non reconductible</TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={{backgroundColor: !!loading ? '#f3f3f3':''}}>
            {data && data.filter(row => paymentWayTranslateMap[row.paymentWay]).map((row: StatByWay) => (
              <TableRow key={row.paymentWay}>
                <TableCell component="th" scope="row">{paymentWayTranslateMap[row.paymentWay]}</TableCell>
                <TableCell component="th" scope="row">{row.period.all}</TableCell>
                <TableCell component="th" scope="row">{row.period.year}</TableCell>
                <TableCell component="th" scope="row">{row.period.month}</TableCell>
                <TableCell component="th" scope="row">{row.period.None}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {!!loading && <LinearProgress color="secondary" />}
    </div>
  );
}

export default PaymentWayTable;